import _ from "lodash"
import { EncounterCodeNextUpdate } from './EncounterCodeNextUpdate'
import { sqlServerDateTimeOffset } from '../util'
import { CodeNext, DraftExportSupplement, Export, Import } from '@fusion-advantage/backcompat'
import { DateTime } from 'luxon'

// we send ClientDateTime as a locally zoned timestamp
// but the server sends back UTC that validates out with zod,
// so emulate that
const encounterUpdateDT = (clientDateTimeStr: string): string => {
	const clientDateTime = DateTime.fromISO(clientDateTimeStr)
	return sqlServerDateTimeOffset(clientDateTime.toUTC())
}

// patch an Export with an unsynced CodeNext update
// while fully offline
export const draftExportApplyCodeNextUpdate = (exp: Export, update: EncounterCodeNextUpdate): Export => {
	const appLastStatusDT = encounterUpdateDT(update.ClientDateTime)
	let dateOfService = exp.Form.Encounter.DateOfService
	if(update.CodeNext === CodeNext.InProgress) {
		dateOfService = dateOfService ?? update.ClientDate
	}
	return {
		Form: {
			Encounter: {
				...exp.Form.Encounter,
				CodeNext: update.CodeNext,
				EncounterLastUpdateDT: appLastStatusDT,
				EncounterAppLastStatusDT: appLastStatusDT,
				DateOfService: dateOfService,
			},
			Member: exp.Form.Member,
			CancelReason: exp.Form.CancelReason,
			ConceptStatuses: exp.Form.ConceptStatuses,
		},
	}
}

// allow an Import (draft) to be used with an Export
// for continuing to edit an Encounter while fully offline
export const draftExportApplyImport = (exp: Export, imp: Import): Export => {
	const lastUpdateDT = encounterUpdateDT(imp.FormResponse.Encounter.ClientDateTime)
	return {
		Form: {
			Encounter: {
				...exp.Form.Encounter,
				EncounterLastUpdateDT: lastUpdateDT,
			},
			Member: exp.Form.Member,
			CancelReason: exp.Form.CancelReason,
			ConceptStatuses: _.keyBy(imp.FormResponse.ConceptStatuses, 'cid'),
		},
	}
}

// this exists as a future placeholder in case we want to
// push any additional draft data to the form renderer for load
export const createDraftExportSupplement = (): DraftExportSupplement|undefined => undefined
